import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { ProgrammeList } from '~/components/programme-list';
import gyerek from '~/data/gyerek.json';
import { processProgrammeData } from '~/lib/programme-utils';
import { PageSection } from '~/routes/__root';

export const Route = createFileRoute('/program/kids')({
  component: RouteComponent,
});

function RouteComponent() {
  // Process gyerek data to group by days
  const dailyData = React.useMemo(() => {
    return processProgrammeData(gyerek);
  }, []);

  const emptyMessage = {
    HU: 'Nincs még elérhető gyerekprogram',
    EN: 'No kids programmes available yet',
    RS: 'Dečji programi još nisu dostupni',
  };

  return (
    <PageSection width="narrow" padding="small">

      <ProgrammeList
        dailyData={dailyData}
        emptyMessage={emptyMessage}
        showAge={true}
      />
    </PageSection>
  );
}

export default RouteComponent;
